import { Link } from "react-router-dom"
import footer_logo from "../assets/img/footer_logo.svg"
import { useState } from "react";
import { useEffect } from "react";
import { CallWithAuth } from "../action/apiActions";
import { ADMIN_CMS_SOCIAL_MEDIA } from "../action/apiPath";
import { showToast } from "../util/toastHelper";

export const Footer = () => {
    const [socialMedia, setSocialMedia] = useState([]);

    useEffect(() => {
        getSocialMedia();
    }, []);

    const getSocialMedia = async () => {
        try {
            const response = await CallWithAuth("GET", ADMIN_CMS_SOCIAL_MEDIA);
            if (response.res.status == 200) {
                setSocialMedia(response?.res?.data?.data);
            } else {
                showToast("error", response.res.data.message);
            }
        } catch (err) {
            const errorMessage = err?.response?.data?.message || err?.message || "Unexpected error occurred";
            showToast("error", errorMessage);
        }
    };

    const socialMediaURL = (platform) => {
        return socialMedia.find(item => item.platform == platform && item.is_active)?.url;
    };

    return (
        <>
            <footer class="site_footer">
                <div class="top_part">
                    <div class="site_container">
                        <div class="site_row">
                            <div class="logo_colm">
                            <Link to="/"> <img src={footer_logo} alt="" /></Link>
                            </div>
                            <div class="footer_menu">
                                <ul>
                                    {/* <li><a href="">About Us</a></li>
                                    <li><a href="">Services</a></li>
                                    <li><a href="">Contact Us</a></li>
                                    <li><a href="">FAQ</a></li> */}
                                    <li><Link to="/about">About Us</Link></li>
                                    <li><Link to="/services">Services</Link></li>
                                    <li><Link to="/contact-us">Contact Us</Link></li>
                                    <li><Link to="/faq">FAQ</Link></li>
                                </ul>
                            </div>
                            {socialMedia.length > 0 ? <div class="social_icon">
                                <ul>
                                    {socialMediaURL("facebook") ? (
                                        <li><a href={socialMediaURL("facebook")} target="_blank"><i class="fa-brands fa-facebook-f"></i></a></li>
                                    ) : null}
                                    {socialMediaURL("linkedin") ? (
                                        <li><a href={socialMediaURL("linkedin")} target="_blank"><i class="fa-brands fa-linkedin-in"></i></a></li>
                                    ) : null}
                                    {socialMediaURL("youtube") ? (
                                        <li><a href={socialMediaURL("youtube")} target="_blank"><i class="fa-brands fa-youtube"></i></a></li>
                                    ) : null}
                                    {socialMediaURL("instagram") ? (
                                        <li><a href={socialMediaURL("instagram")} target="_blank"><i class="fa-brands fa-instagram"></i></a></li>
                                    ) : null}
                                </ul>
                            </div> : null}
                        </div>
                    </div>
                </div>
                <div class="bottom_part">
                    <div class="site_container">
                        <div class="site_row">
                            <p>© {new Date().getFullYear()}. All rights reserved.</p>
                            <Link to={'/privacy-policy'}>Privacy Policy</Link>
                            <Link to={'/terms-condition'}>Terms and Condition</Link>
                            {/* <Link to={'/cookies-policy'}>Cookie Policy</Link> */}
                            {localStorage.getItem("accessToken") != null && (<Link to={'/support-request'}>Connect With support</Link>)}
                           
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}